import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, CanActivate, RouterStateSnapshot } from "@angular/router";
import { AuthService } from "../auth/auth.service";

@Injectable({
  providedIn: 'root'
})
export class GroupGuardService implements  CanActivate{

  constructor(private authService: AuthService) { }

  async canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Promise<boolean> {
    const groups =  this.authService.getGroups();
    // Add cases for each flow type
    if (state.url.indexOf('/') > -1) {
      return this.onboardCheck(groups);
    } else {
      return false;
    }
  }

  // Update group checks when actual values are known
  onboardCheck(groups: string[] | undefined): boolean {
    return groups!.indexOf('Everyone') > -1;
  }

}
